import { render } from "./TBody.vue?vue&type=template&id=48d1f282&scoped=true"
import script from "./TBody.vue?vue&type=script&lang=js"
export * from "./TBody.vue?vue&type=script&lang=js"

import "./TBody.vue?vue&type=style&index=0&id=48d1f282&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d1f282"]])

export default __exports__